/**
 * @prettier
 */
import React, { Component } from "react"
import PropTypes from "prop-types"
import { Map } from "immutable"
const propClass = "property primitive"

export default class Primitive extends Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        getComponent: PropTypes.func.isRequired,
        getConfigs: PropTypes.func.isRequired,
        name: PropTypes.string,
        displayName: PropTypes.string,
        depth: PropTypes.number,
        expandDepth: PropTypes.number,
    }

    render() {
        let {
            schema,
            getComponent,
            getConfigs,
            name,
            displayName,
            depth,
        } = this.props

        const { showExtensions } = getConfigs()

        if (!schema || !schema.get) {
            // don't render if schema isn't correctly formed
            return <div></div>
        }

        let type = schema.get("type")
        let format = schema.get("format")
        let xml = schema.get("xml")
        let enumArray = schema.get("enum")
        let title = schema.get("title") || displayName || name
        let description = schema.get("description")
        const extensions = this.getExtensions(schema)

        let properties = schema
            .filter(
                (_, key) =>
                    [
                        "enum",
                        "type",
                        "format",
                        "description",
                        "$$ref",
                        "externalDocs",
                    ].indexOf(key) === -1
            )
            .filterNot((_, key) => extensions.has(key))
        let externalDocsUrl = schema.getIn(["externalDocs", "url"])
        let externalDocsDescription = schema.getIn(["externalDocs", "description"])

        const Markdown = getComponent("Markdown", true)
        const EnumModel = getComponent("EnumModel")
        const Property = getComponent("Property")
        const Link = getComponent("Link")
        const ModelExtensions = getComponent("ModelExtensions")
        return (
            <span className="model">
          <span className="prop">
            {name && depth > 1 && <span className="prop-name">{title}</span>}
              <span className="prop-type">{type}</span>
              {format && <span className="prop-format">(${format})</span>}
              {properties.size
                  ? properties
                      .entrySeq()
                      .map(([key, v]) => (
                          <Property
                              key={`${key}-${v}`}
                              propKey={key}
                              propVal={v}
                              propClass={propClass}
                          />
                      ))
                  : null}
              {showExtensions && extensions.size > 0 ? (
                  <ModelExtensions
                      extensions={extensions}
                      propClass={`${propClass} extension`}
                  />
              ) : null}
              {!description ? null : <Markdown source={description} />}
              {externalDocsUrl && (
                  <div className="external-docs">
                      <Link target="_blank" href={this.sanitizeUrl(externalDocsUrl)}>
                          {externalDocsDescription || externalDocsUrl}
                      </Link>
                  </div>
              )}
              {xml && xml.size ? (
                  <span>
                <br />
                <span className={propClass}>xml:</span>
                      {xml
                          .entrySeq()
                          .map(([key, v]) => (
                              <span key={`${key}-${v}`} className={propClass}>
                      <br />
                                  &nbsp;&nbsp;&nbsp;{key}: {String(v)}
                    </span>
                          ))
                          .toArray()}
              </span>
              ) : null}
              {enumArray && (
                  <EnumModel value={enumArray} getComponent={getComponent} />
              )}
          </span>
      </span>
        )
    }

    getExtensions = (defObj) => {
        const extensionRegExp = /^x-/
        if(Map.isMap(defObj)) {
            return defObj.filter((v, k) => extensionRegExp.test(k))
        }
        return Object.keys(defObj).filter((key) => extensionRegExp.test(key))
    }

    sanitizeUrl(url) {
        if (typeof url !== "string" || url.trim() === "") {
            return ""
        }

        const urlTrimmed = url.trim()
        const blankURL = "about:blank"

        try {
            const base = `https://base${String(Math.random()).slice(2)}`
            const urlObject = new URL(urlTrimmed, base)
            const scheme = urlObject.protocol.slice(0, -1)

            // check for invalid schemes
            if (["javascript", "data", "vbscript"].includes(scheme.toLowerCase())) {
                return blankURL
            }

            // return sanitized URI reference
            if (urlObject.origin === base) {
                return urlTrimmed.startsWith("/")
                    ? `${urlObject.pathname}${urlObject.search}${urlObject.hash}`
                    : urlTrimmed.startsWith(".")
                        ? `.${urlObject.pathname}${urlObject.search}${urlObject.hash}`
                        : `${urlObject.pathname.substring(1)}${urlObject.search}${urlObject.hash}`
            }

            return String(urlObject)
        } catch {
            return blankURL
        }
    }
}
